import axios from 'axios';
import Deadline from '@/models/deadline';
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_DEADLINE_URL = process.env.VUE_APP_API_URL+"/deadlines";

export default class DeadlineController {
  // Fetch all deadlines
  static async fetchDeadlines() {
      const response = await axios.get(`${API_DEADLINE_URL}/get_deadlines`);
      console.log('Deadlines fetched successfully:', response.data);
      return response.data.map(dl => new Deadline(dl));
  }

  // Fetch deadline by ID
  static async fetchDeadlineById(deadlineId) {
      const response = await axios.get(`${API_DEADLINE_URL}/get_deadline_by_id/${deadlineId}`);
      return new Deadline(response.data);
  }

  static async fetchLatestDeadline() {
    try {
        const response = await axios.get(`${API_DEADLINE_URL}/get_latest_deadline`);
        return new Deadline(response.data);
    }
    // catch error response status code 404
    catch (error) {
        if (error.response && error.response.status === 404) {
            console.log("No deadlines found, returning null");
            return null;
        }
        throw error; // rethrow the error if it's not a 404
    }
  }

  // Create a new deadline
  static async createDeadline(deadlineData) {
      // Validate data using Deadline model
      Deadline.validate(deadlineData);
      // Normalize the date to end-of-day
      deadlineData.date = Deadline.normalizeDeadlineDate(deadlineData.date);
      const response = await axios.post(`${API_DEADLINE_URL}/create_deadline`, deadlineData);
      return new Deadline(response.data);
  }

  // Update an existing deadline
  static async updateDeadline(deadlineId, deadlineData) {
      // Validate data using Deadline model
      Deadline.validate(deadlineData);
      // Normalize the date to end-of-day
      deadlineData.date = Deadline.normalizeDeadlineDate(deadlineData.date);
      const response = await axios.put(`${API_DEADLINE_URL}/update_deadline/${deadlineId}`, deadlineData);
      return new Deadline(response.data);
  }

  // Delete a deadline by ID
  static async deleteDeadline(deadlineId) {
      const response = await axios.delete(`${API_DEADLINE_URL}/delete_deadline/${deadlineId}`);
      return response.data;
  }
}

applyErrorHandlers(DeadlineController);
